module.exports = __webpack_public_path__ + "img/Booking-Options.07224d1b.jpg";